const Graphics = {
  _renderer: null,
  _renderState: null,
  _container: null,

  render(scene, camera, renderTarget) {
    if (!this._renderer || !camera || !scene) return;
    if (renderTarget !== undefined) {
      this._renderer.setRenderTarget(renderTarget || null);
    }
    this._renderer.render(scene, camera);
    if (renderTarget !== undefined) {
      this._renderer.setRenderTarget(null);
    }
  },

  clear(renderTarget, camera, clearDepth, clearColor) {
    if (!this._renderer) return;
    if (renderTarget !== undefined) {
      this._renderer.setRenderTarget(renderTarget || null);
    }
    if (camera && camera.clear_color) {
      this._renderer.setClearColor(camera.clear_color, camera.clear_alpha);
    }
    this._renderer.clear(!!clearColor, !!clearDepth, false);
  },

  set_state(renderState) {
    this._renderState = renderState;
  },

  update() {
    if (!this._renderer || !this._container) return;
    const w = this._container.clientWidth;
    const h = this._container.clientHeight;
    this._renderer.setSize(w, h, false);
  },

  take_screenshot(callback) {
    if (!this._renderer) return;
    this._renderer.domElement.toBlob(blob => {
      if (callback) callback(blob);
    }, 'image/png');
  },

  download_screenshot(blob) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'screenshot.png';
    a.click();
    URL.revokeObjectURL(url);
  },
};

export { Graphics };
